<template>
  <div id="caixasParametros">
    <div class="text-right">
      <q-btn flat round class="q-ml-md" icon="settings" color="primary" @click="openModalOptions()" />
    </div>

    <q-table
      title
      :rows="caixas"
      :columns="columns"
      row-key="name"
      :separator="separator"
      :loading="loadCaixas"
      no-data-label="Nenhum resultado encontrado."
      v-model:pagination="pagination"
    >
      <template v-slot:bottom>
        <div></div>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td key="id" class="text-right">{{ props.row.id }}</q-td>
          <q-td key="nome">{{ props.row.nome }}</q-td>
          <q-td key="numero" class="text-left">{{ props.row.numero }}</q-td>
          <q-td class="tdfora">
            <div class="divfora">
              <div class="divdentro q-gutter-sm" style="margin-right: 10px">
                <q-btn @click="editar(props.row)" size="12px" class="bg-primary text-white" icon="edit" />
                <q-btn @click="excluir(props.row)" class="bg-negative text-white" icon="block" size="12px" />
              </div>
            </div>
          </q-td>
        </q-tr>
      </template>
    </q-table>

    <q-dialog v-model="modalOptions" persistent>
      <q-card style="max-width: 900px; width: 90%">
        <q-card-section class="row items-center">
          <div class="text-h6">Opções</div>
          <q-space />
          <q-btn flat round dense icon="close" v-close-popup @click="closeModalOptions()" />
        </q-card-section>

        <q-separator />

        <q-card-section class="q-pa-md">
          <div class="row q-col-gutter-lg">
            <div class="col-6">
              <div class="col-12">
                <q-checkbox
                  label="Permitir cancelamento de saldo inicial"
                  v-model="options.movcaixas_permitir_cancelar_saldo_inicial"
                  true-value="1"
                  false-value="0"
                  color="green"
                />
              </div>
              <div class="col-12">
                <q-checkbox
                  label="Permitir cancelamento de contas abertas criadas pelo caixa fechado"
                  v-model="options.movcaixas_cancelar_movconta_aberta"
                  true-value="1"
                  false-value="0"
                  color="green"
                />
              </div>
              <div class="col-12">
                <q-checkbox
                  label="Permitir o estorno de liquidação de contas atreladas ao caixa fechado"
                  v-model="options.movcaixas_cancelar_movconta_liquidada"
                  true-value="1"
                  false-value="0"
                  color="green"
                />
              </div>
              <div class="col-12">
                <q-checkbox
                  label="Permitir o estorno de sangrias que foram utilizadas em depósitos/transferências"
                  v-model="options.movcaixas_cancelar_sangria_deposito"
                  true-value="1"
                  false-value="0"
                  color="green"
                />
              </div>
              <div class="col-12">
                <q-checkbox
                  label="Venda detalhada"
                  v-model="options.movcaixas_venda_detalhada"
                  true-value="1"
                  false-value="0"
                  color="green"
                />
              </div>
              <div class="col-12">
                <q-checkbox
                  label="Compra detalhada"
                  v-model="options.movcaixas_compra_detalhada"
                  true-value="1"
                  false-value="0"
                  color="green"
                />
              </div>
              <div class="col-12">
                <q-checkbox
                  label="Permitir uma venda com quantidade e valor maior que o resumo"
                  v-model="options.movcaixas_permitir_venda_maior_que_resumo"
                  true-value="1"
                  false-value="0"
                  color="green"
                />
              </div>
              <div class="col-12">
                <q-checkbox
                  label="Utilizar PREST CONT"
                  v-model="options.movcaixas_utiliza_prest_cont"
                  true-value="1"
                  false-value="0"
                  color="green"
                />
              </div>
              <div class="col-12">
                <q-checkbox
                  label="Validar estoque de moedas no reforço/sangria"
                  v-model="options.movcaixas_validar_estoque_moedas"
                  true-value="1"
                  false-value="0"
                  color="green"
                />
              </div>
              <div class="col-12">
                <q-checkbox
                  label="Permitir recebimento de múltiplas contas"
                  v-model="options.movcaixas_receber_multiplos"
                  true-value="1"
                  false-value="0"
                  color="green"
                />
              </div>
              <div class="col-12 q-mb-md">
                <q-select
                  emit-value
                  map-options
                  label="Bloquear a abertura do caixa"
                  :options="optionsBloquearCaixa"
                  v-model="options.movcaixas_bloquear_abertura"
                />
              </div>
            </div>

            <div class="col-6">
              <div class="text-subtitle2 q-mb-sm">Nomenclaturas Caixa</div>
              <div class="q-pa-sm">

                <q-input
                  label="Arrecadação de Prognósticos (ARREC. PROG)"

                  v-model="options.movcaixas_nomenclatura_arrec_prog"
                  placeholder="ARREC. PROG"
                />

                <q-input
                  label="Créditos de Serviços Prestados (COV CR AUT)"
                  v-model="options.movcaixas_nomenclatura_cov_cr_aut"
                  placeholder="Cov Cr Aut"
                />

                <q-input
                  label="Pagamentos de Contas (CRE CXAQUI)"
                  v-model="options.movcaixas_nomenclatura_cre_cxaqui"
                  placeholder="CRE CXAQUI"
                />

                <q-input
                  label="Recebimentos de Contas (DEB CXAQUI)"
                  v-model="options.movcaixas_nomenclatura_deb_cxaqui"
                  placeholder="DEB CXAQUI"
                  />

                <q-input
                  label="Pagamentos de Prêmios (PREMIO LOT)"
                  v-model="options.movcaixas_nomenclatura_premio_lot"
                  placeholder="PREMIO LOT"
                />

                <q-input
                  label="Transaçãoes de PIX (PIX PAGAMENTO)"
                  v-model="options.movcaixas_nomenclatura_pix_pagamento"
                  placeholder="PIX"
                />

                <q-input
                  label="Transaçãoes de Cartão (AZCX)"
                  v-model="options.movcaixas_nomenclatura_cartao"
                  placeholder="AZCX"
                />

              </div>

            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            clickable
            v-ripple
            dense
            flat
            class="text-red text-caption"
            label="Reverter nomenclaturas"
            @click="reverterParaAnterior"
          />

          <q-btn
            label="Salvar"
            clickable
            v-ripple
            @click="salvarOpcoes()"
            :loading="salvandoOpcoes"
            color="green"
            text-color="white"
            style="margin-right: 22px; margin-bottom: 10px"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Loading } from 'quasar';
import axios from '@/axios-auth';

export default {
  name: 'CaixasParametros',
  data() {
    return {
      separator: 'horizontal',
      modalOptions: false,
      pagination: {
        rowsPerPage: 0,
      },
      columns: [
        {
          name: 'id',
          required: true,
          label: 'ID',
          align: 'right',
          field: (row) => row.id,
          format: (val) => `${val}`,
          sortable: true,
        },
        {
          name: 'nome',
          align: 'left',
          label: 'Nome',
          field: (row) => row.nome,
          sortable: true,
        },
        {
          name: 'numero',
          label: 'Número',
          field: (row) => row.numero,
          sortable: true,
          align: 'left',
        },
        { name: 'tdfora' },
      ],
      salvandoOpcoes: false,
      options: {
        movcaixas_permitir_cancelar_saldo_inicial: '0',
        movcaixas_cancelar_movconta_aberta: '0',
        movcaixas_cancelar_movconta_liquidada: '0',
        movcaixas_cancelar_sangria_deposito: '0',
        movcaixas_venda_detalhada: '0',
        movcaixas_compra_detalhada: '0',
        movcaixas_permitir_venda_maior_que_resumo: '0',
        movcaixas_utiliza_prest_cont: '0',
        movcaixas_validar_estoque_moedas: '0',
        movcaixas_receber_multiplos: '0',
        movcaixas_bloquear_abertura: '0',
        movcaixas_nomenclatura_arrec_prog: '',
        movcaixas_nomenclatura_cov_cr_aut: '',
        movcaixas_nomenclatura_cre_cxaqui: '',
        movcaixas_nomenclatura_deb_cxaqui: '',
        movcaixas_nomenclatura_premio_lot: '',
        movcaixas_nomenclatura_pix_pagamento: '',
        movcaixas_nomenclatura_cartao: '',
      },
      optionsOriginais: {},
      optionsBloquearCaixa: [
        { label: 'Nenhum bloqueio', value: '0' },
        { label: 'Mesmo caixa mais de uma vez', value: '1' },
        { label: 'Mesmo operador mais de uma vez', value: '2' },
        { label: 'Mesmo caixa ou operador mais de uma vez', value: '3' },
      ],
    };
  },
  computed: {
    ...mapGetters(['caixas', 'loadCaixas']),
  },
  methods: {
    editar(caixa) {
      this.$store.dispatch('editarCaixa', caixa);
    },
    excluir(caixa) {
      this.$store.dispatch('excluirCaixa', caixa);
    },
    openModalOptions() {
      this.modalOptions = true;
      axios
        .get('/caixas/options')
        .then((res) => {
          if (!res.data.success) {
            this.$q.notify({
              message: res.data.message,
              color: 'orange',
              position: 'top-right',
            });
            return;
          }

          this.options = { ...res.data.options };
        })
        .catch(() => {
          this.$q.notify({
            message: 'Não foi possível contactar, ou você não possui permissão!',
            color: 'red',
            position: 'top-right',
          });
        });
    },
    closeModalOptions() {
      this.modalOptions = false;
    },
    salvarOpcoes() {
      if (this.salvandoOpcoes) return;
      this.salvandoOpcoes = true;

      this.$q
        .dialog({
          title: 'Confirmar',
          message: `Confirma a alteração?`,
          cancel: 'Cancelar',
          persistent: true,
        })
        .onOk(() => {
          Loading.show();
        })
        .onOk(() => {
          this.requestSalvarOpcoes();
        })
        .onCancel(() => {
          this.salvandoOpcoes = false;
          Loading.hide();
        })
        .onDismiss(() => {
          this.salvandoOpcoes = false;
          Loading.hide();
        });
    },
    requestSalvarOpcoes() {
      this.salvandoOpcoes = true;
      axios
        .post('/caixas/options', this.options)
        .then((res) => {
          this.salvandoOpcoes = false;
          this.$q.notify({
            message: res.data.message,
            color: res.data.success ? 'green' : 'orange',
            position: 'top-right',
          });
          if (!res.data.success) {
            return;
          }
          this.options = { ...res.data.options };

          this.closeModalOptions();
        })
        .catch(() => {
          this.salvandoOpcoes = false;
          this.$q.notify({
            message: 'Houve um erro ao salvar as opções, tente novamente!',
            color: 'red',
            position: 'top-right',
          });
        });
    },
    reverterParaAnterior() {
      this.$q
        .dialog({
          title: 'Confirmação',
          message:
            'As nomenclaturas serão atualizadas para a versão anterior. Deseja continuar?',
          cancel: 'Cancelar',
          persistent: true,
        })
        .onOk(() => {
          Loading.show();
          axios
            .post('/caixas/options?reverterNomenclaturas=1')
            .then((res) => {
              Loading.hide();
              if (!res.data.success) {
                this.$q.notify({
                  message:
                    res.data.message || 'Falha ao reverter nomenclaturas.',
                  color: 'orange',
                  position: 'top-right',
                });
                return;
              }
              this.options = { ...res.data.options };

              this.$q.notify({
                message: res.data.message || 'Nomenclaturas revertidas com sucesso.',
                color: 'green',
                position: 'top-right',
              });
              this.closeModalOptions();
            })
            .catch(() => {
              Loading.hide();
              this.$q.notify({
                message:
                  'Erro ao contactar o servidor para reverter nomenclaturas.',
                color: 'red',
                position: 'top-right',
              });
            });
        });
    },
    atualizarPrestCont(val) {
      if (val === '1') {
        this.options.movcaixas_nomenclatura_cre_cxaqui = 'PREST CONT';
        this.options.movcaixas_nomenclatura_deb_cxaqui = 'PREST CONT';
      }
    },
  },
  watch: {
    'options.movcaixas_utiliza_prest_cont': function (val) {
      this.atualizarPrestCont(val);
    },
  },
  mounted() {
    this.$store.dispatch('caixas');
  },
};
</script>

<style lang="stylus" scoped>
.q-table__card {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
